/*
 * Yulan TCG - met a jour la barre « livraison offerte » a chaque
 * modification du panier (ajout, changement de quantite, suppression).
 * Le rendu initial est fait en Liquid par snippets/yulan-free-shipping-bar.liquid.
 */
(function () {
  if (window.__yulanCartBarInit) return;
  window.__yulanCartBarInit = true;

  var PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents === null) return '0';
    var number = (cents / 100.0).toFixed(precision);
    var parts = number.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var fraction = parts[1] ? decimal + parts[1] : '';
    return whole + fraction;
  }

  function formatMoney(cents, format) {
    var formatString = format || '{{amount}}';
    var match = formatString.match(PLACEHOLDER);
    if (!match) return formatString;

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }

    return formatString.replace(PLACEHOLDER, value);
  }

  function render(cart) {
    var bars = document.querySelectorAll('[data-yulan-shipping-bar]');

    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
      var format = bar.getAttribute('data-money-format') || '';
      var total = cart.total_price || 0;
      var count = cart.item_count || 0;

      if (!threshold || count === 0) {
        bar.hidden = true;
        continue;
      }

      bar.hidden = false;

      var remaining = threshold - total;
      var percent = Math.min(100, Math.round((total * 100) / threshold));
      var text = bar.querySelector('[data-yulan-shipping-text]');
      var fill = bar.querySelector('[data-yulan-shipping-fill]');

      if (text) {
        text.innerHTML =
          remaining > 0
            ? 'Plus que <strong>' + formatMoney(remaining, format) + '</strong> pour la livraison offerte en point relais'
            : '<strong>Livraison offerte en point relais&nbsp;!</strong> À domicile, 2,99&nbsp;€ sont déduits du tarif.';
      }

      if (fill) {
        fill.style.width = percent + '%';
        if (remaining > 0) {
          fill.classList.remove('yulan-shipping-bar__fill--complete');
        } else {
          fill.classList.add('yulan-shipping-bar__fill--complete');
        }
      }
    }
  }

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart.js';
  }

  var pending = false;

  function refresh() {
    if (pending) return;
    if (!document.querySelector('[data-yulan-shipping-bar]')) return;
    pending = true;

    fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        pending = false;
        render(cart);
      })
      .catch(function () {
        pending = false;
      });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  } else {
    document.addEventListener('cart:refresh', refresh);
  }
})();
